<template>
	<!-- Content -->
	<div :class="{ 'opacity-50': status == 'feedback' }">

		<!-- Question -->
		<div class="m-auto" style="max-width: 700px;">
			<span class="h5" v-html="getText(question.id, 'text')"></span>
			<hr>
		</div>

		<!-- Elements -->
		<div class="d-flex mt-4 justify-content-center no-select">
			<div class="d-flex flex-wrap blockquote position-relative">

				<draggable v-model="boxes" v-bind="dragOptions" group="boxes" @start="drag=true; tryReset();" @end="drag=false" :disabled="lockInput">
					<div v-for="(box,index) in boxes" :key="index" class="list-element d-flex">
						<div class="position-relative w-100 text-center">
							{{ getAnswerText(box.index) }}
							<input
							v-if="status != 'verify'"
							type="radio"
							role="button"
							style="position: absolute; left: -2em; top: 50%; transform: translate(-50%, -50%);"
							class="form-check-input"
							:class="{ 'checkbox-correct': box.styleCorrect, 'checkbox-incorrect': box.styleIncorrect }"
							checked>
						</div>
					</div>
				</draggable>

				<div class="position-absolute w-100 pointer-events-none">
					<div v-for="(box,index) in boxes" :key="box.index" v-if="index < boxes.length-1" class="list-element fake">
						<div style="position: relative;">
							<span class="opacity-0">{{ getAnswerText(box.index) }}</span>
							<div class="list-arrow">
								<!-- &#9660; -->
								&#8964;
								<!-- &darr; -->
							</div>
						</div>
					</div>
				</div>

			</div>
		</div>

		<!-- Button and hint area -->
		<div v-if="status != 'feedback'" class="mt-4">
			<div class="m-auto" style="max-width: 700px;">
				<hr>
			</div>

			<!-- Help text -->
			<div class="mb-3">
				<div v-if="status == 'verify'" class="text-muted">
					<span>
						{{ $t('quiz_hint_sequence') }}
					</span>
				</div>
				<div v-if="status == 'try-again'" class="text-danger">
					<span>
						{{ $t('quiz_try_again') }}
					</span>
				</div>
				<div v-if="status == 'success'" class="text-success">
					<span>
						{{ $t('quiz_correct') }}
					</span>
				</div>
			</div>

			<!-- Answer button -->
			<div v-if="status == 'verify'">
				<button
					class="btn px-5 progress-bar-striped"
					:class="{ 'btn-primary': allowSubmit, 'btn-secondary': !allowSubmit, 'progress-bar-animated': allowSubmit }"
					@click="verify"
					:disabled="!allowSubmit">
					{{ $t('quiz_button_verify') }}
				</button>
			</div>
			<div v-else-if="status == 'try-again'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-danger"
					@click="tryAgain">
					{{ $t('quiz_button_try_again') }}
				</button>
			</div>
			<div v-else-if="status == 'success'">
				<button
					class="btn px-5 progress-bar-striped progress-bar-animated btn-success"
					@click="complete">
					{{ $t('continue') }}
				</button>
			</div>
		</div>
	</div>
</template>



<script>
import draggable from 'vuedraggable';
import Timer from '@/components/Timer';

export default {
	props: [ "question", "selectedIndex" ],
	components: { draggable },
	data() {
		return {
			id: null,
			status: null,
			lockInput: false,
			boxes: [],
			answerIds: [],
			numberOfAnswers: 0,
			current: null,
			drag: false,
			previousAnswer: null,
			allowSubmit: false,

			timer: null,
		};
	},
	methods: {
		load(question) {
			this.id = question.id;
			// question.difficulty
			this.status = 'verify';
			this.lockInput = false;
			this.answerIds = question.answerIds;

			this.boxes = [];
			for (let i = 0; i < question.answers.length; i++) {

				this.boxes.push({
					index: question.answers[i] - 1,
					correctIndex: question.correct[i] - 1,
					key: question.answerIds[i],
					styleCorrect: false,
					styleIncorrect: false,
					active: false
				});

			}

			if (question.shuffle) {
				// Continue shuffling until order does not match the answer
				let limit = 100;
				do {
					this.shuffle(this.boxes);
				}
				while (this.needShuffle() && limit-- > 0)
			}

			this.allowSubmit = false;
			this.previousAnswer = this.currentAnswers;

			// Log new question
			if (!this.$tracker.isTaskComplete(this.id)) {
				this.$log.onQuestionStart(this.id, question.mechanic, this.selectedIndex+1, this.currentAnswers, question.correct);
				this.$tracker.onTaskStart(this.id);
			}
			// Auto-complete answers
			else {
				this.verify(null, true);
			}
		},
		needShuffle() {
			for (const i in this.boxes) {
				if (i == this.boxes[i].correctIndex) {
					return true;
				}
			}
			return false;
		},
		verify(event, autoComplete=false) {
			if (autoComplete) {
				this.boxes.sort((a,b) => a.correctIndex - b.correctIndex);
			}

			let allCorrect = true;

			for (const i in this.boxes) {
				const box = this.boxes[i];

				box.styleCorrect = (i == box.correctIndex);
				box.styleIncorrect = (i != box.correctIndex);

				if (i != box.correctIndex) {
					allCorrect = false;
				}
			}

			if (autoComplete) {
				this.status = 'feedback';
				this.lockInput = true;
			}
			else {
				this.$log.onQuestionVerify(this.id, this.currentAnswers, allCorrect);
				if (allCorrect) {
					this.status = 'success';
					this.$emit("complete");
					this.$log.onQuestionComplete(this.id);
					this.$tracker.onTaskComplete(this.id, this.timer.elapsed);
					this.lockInput = true;
				}
				else {
					this.status = 'try-again';
					// this.lockInput = true;
					this.$tracker.onTaskMistake();
				}
			}
		},
		complete() {
			this.status = 'feedback';
			this.$emit("progress");
			this.$log.onQuestionNext(this.id);
		},
		tryReset() {
			if (this.status == 'try-again') {
				this.tryAgain();
			}
		},
		tryAgain() {
			this.status = 'verify';
			this.lockInput = false;
			this.allowSubmit = false;
			this.$log.onQuestionTryAgain(this.id);

			for (let box of this.boxes) {
				box.styleCorrect = false;
				box.styleIncorrect = false;
			}
		},
		getAnswerText(index) {
			return this.getText(this.answerIds[index]);
			// return this.getText(this.question.id, 'answer_' + index);
		}
	},
	computed: {
		dragOptions() {
			return {
				animation: 100,
				group: "description",
				disabled: false,
			};
		},
		currentAnswers() {
			return this.boxes.map(box => box.index+1);
		}
	},
	watch: {
		question(newData) {
			this.load(newData);
		},
		currentAnswers() {
			this.$log.onQuestionChangeAnswer(this.id, this.currentAnswers);
			if (this.previousAnswer != this.currentAnswers) {
				this.previousAnswer = null;
				this.allowSubmit = true;
			}
		}
	},
	mounted() {
		this.timer = new Timer();
		this.load(this.question);
	},
	beforeDestroy() {
		if (this.timer) {
			this.timer.clear();
		}
	}
};
</script>



<style scoped>
	.wrapper {
	}

	.form-check-input {
		margin: 0;
		border-color: transparent !important;
	}


	.list-element {
		margin: 1.75rem 0.5em;
		border: 1px solid gray;
		border-radius: 0.5em;
		padding: 0.5em 1em;
		box-shadow: 0 0.25rem 0.5rem rgb(0 0 0 / 10%);
	}
	.list-element:first-child { margin-top: 0; }
	.list-element:last-child { margin-bottom: 0; }
	.list-element:hover {
		background: #ECEFF1;
	}

	.fake {
		border-color: rgba(0, 0, 0, 0);
	}

	.list-arrow {
		position: absolute;
		left: 50%;
		font-size: 2em;
		top: calc(100% - 0.35em);
		transform: translateX(-50%);
	}
</style>
